<template>
	<div>
		<Row type="flex" justify="center" align="center" class="row">
			<Col span="2">
				<Icon @click="to" style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="18">
				{{menuName}} 
			</Col>
			<Col span="4" style="text-align: center;">
				<slot></slot>
			</Col>
		</Row>
		<Divider v-if="border" style="margin-top: 0px;height: 2px;" />
	</div>
</template>
<script>
	export default {
		name: 'Top',
		props: {
			menuName: String,
			prevUrl:String,
			border:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {}
		},
		methods: {
			to(){
				this.$router.push(this.prevUrl);
			}
		}
	}
</script>
<style>
	.row{
		height: 52px;
		width: 100%; 
		background: #eceef1;
		line-height: 52px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/assembly/index.vue